<template>
<div class="col-md-8 pl-md-4 pr-md-4">
      <div class="text-center text-md-left">
        <div style="font-size:1.3rem;font-weight:500;">{{ product.name }}</div>
        <div class="mt-2">
          <span v-if="product.stock > 0" style="color:#238a59;"><i class="fas fa-check-circle mr-2"></i>{{product.stock}} In stock <span class="collection">{{product.seller.business_suburb}}, {{product.seller.business_city}}</span></span>
          <span v-else style="color:#ff2626;"><i class="fa-solid fa-circle-xmark mr-2"></i>Out of stock</span>
        </div>
        <div v-if="product.stock > 0" class="mb-2 mt-2">
          <i class="far fa-clock mr-2"></i>Get it on <span class="collection" style="background: #0b705e;
  color: white;">{{deliveryDate}}</span>
        </div>
        
        <div class="mt-2"><i class="fas fa-user mr-2"></i>Sold by <a :href="`/seller/${product.seller.id}/${createSlug(product.seller.business_name)}`" class="blue2">{{product.seller.business_name}}</a></div>
        <div class="mt-2" v-if="averageReviews > 0"><review-stars :stars="averageReviews" :total="product.reviews.length"></review-stars></div>
        <div class="mt-2" style="font-size:1.2rem;font-weight:600;">R {{product.price}}</div>
        <div class="mt-3" v-if="!this.logged && product.seller.id != 1"><a href="#/" @click="whatsappMessage()" class="btn btn-dark px-3"><i class="fab fa-whatsapp mr-2"></i>Chat with seller</a></div>
        <div class="mt-3" v-else-if="product.seller.business_phone && whatsappLink && product.seller.id != 1" v-html="whatsappLink"></div>
        <div class="mt-4" v-if="product.stock > 0">
          <a v-if="adding" href="#/" class="btn btn-success col col-md-4"><i class="fas fa-spinner fa-spin"></i></a>
          <a v-else href="#/" class="btn btn-success col col-md-4" @click="addToCart"><i class="fas fa-shopping-cart mr-3"></i>Add to Cart</a>
        </div>
        </div>
        <pre>
          <div class="product_description"
          v-html="formatDescription(product.description)"
          v-linkified></div>
        </pre>
    </div>
</template>

<script>
import { EventBus } from '../bus';

export default {
props : ['product', 'averageReviews', 'whatsappLink', 'logged'],

data() {
    return {
      adding: false,
    };
  },

computed: {
        deliveryDate() {
          const days = 7;
          let date = new Date();
          date.setDate(date.getDate() + days);

          const day = date.getDate();
          const month = date.toLocaleString('default', { month: 'long' });
          const year = date.getFullYear();

          return `${day} ${month} ${year}`;
      }
  },

  methods: {

    whatsappMessage() {
      this.sweetfire('Please login to chat with seller');
    },

    sweetfire(text) {
      Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirmButton: false,
        cancelButtonText: "Ok",
        customClass: { title: "popup-title" },
      });
    },

    addSuccess(message) {
      Swal.fire({
        icon: 'success',
        title: message,
        customClass: {
          title: "confirm-title",
          icon: 'custom-icon-size'
        },
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'View cart',
        denyButtonText: 'Checkout',
        cancelButtonText: 'Continue shopping',
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = '/cart';
        } else if (result.isDenied) {
          window.location.href = '/checkout';
        }
      });
    },

    addToCart() {
      if (!this.logged) {
        this.sweetfire('Please login to start shopping');
      } else {
        this.adding = true;
        axios
        .post('/cart/add', {
          product_id: this.product.id,
          quantity: 1,
        })
        .then((response) => {

          if (response.data.success) {
            EventBus.$emit('update-cart', this.product);
            this.addSuccess('Product added to cart');
          } else {
            this.sweetfire(response.data.message);
          }
          
          this.adding = false;
        
        });
      }
    },

  },
};
</script>